import { render, staticRenderFns } from "./huiyi-index.vue?vue&type=template&id=2a69b230"
import script from "./huiyi-index.vue?vue&type=script&lang=js"
export * from "./huiyi-index.vue?vue&type=script&lang=js"
import style0 from "./huiyi-index.vue?vue&type=style&index=0&id=2a69b230&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports